export default function capitalize(string) {
  if (string && string.length > 0) {
    return string.toLowerCase().replace(/\b(\w)/g, (x) => x.toUpperCase());
  }
  return "";
}
